import React from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { ThreeDots } from 'react-loader-spinner';
import JsonEditorPane from '../Panes/Json/JsonEditorPane';
import ResponseHeaderPane from '../Panes/ResponseHeader/ResponseHeaderPane';

export default function ResponseTabGroup({ doc, setDoc, response, setResponse, loading }) {
  const responseTabs = [
    {
      slug: 'response-body',
      title: 'Response Body',
    },
    {
      slug: 'response-header',
      title: 'Response Header',
    },
  ];

  return (
    <Tabs forceRenderTabPanel selectedTabClassName="border-b-2 border-[#fdb814] text-[#fdb814]" className="flex flex-col h-full">
      <TabList className="flex bg-gradient-to-r from-gray-50 to-white border-b-2 border-gray-200 flex-shrink-0">
        {responseTabs.map((tab) => (
          <Tab
            className="py-3 px-6 text-sm font-semibold border-b-2 border-transparent focus:outline-none hover:text-[#fdb814] hover:border-[#fdb814]/30 cursor-pointer transition-all duration-200"
            key={tab.slug}
          >
            {tab.title}
          </Tab>
        ))}
      </TabList>
      <div className="flex-1 overflow-auto py-6 px-6 bg-white">
        {loading ? (
          <div className="flex items-center justify-center h-full">
            <ThreeDots height="40" width="40" color="#fdb814" visible={true} />
          </div>
        ) : (
          <>
            <TabPanel>
              <JsonEditorPane
                paneValue={doc}
                setPaneValue={setDoc}
                isEditable={false}
              />
            </TabPanel>
            <TabPanel>
              <ResponseHeaderPane response={response} />
            </TabPanel>
          </>
        )}
      </div>
    </Tabs>
  );
}